import {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    object,
    moreNav,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
} from './ThirdMapping';

var entitiesTabs = [
    {
        label: Loc.g('Activité'),
        value: 'activity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Éléments épinglés'),
        value: 'pinned',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Commentaires'),
        value: 'note',
        entities: ['annotation'],
        databot: 'order-overview__activity--comment-list',
    },
    {
        label: Loc.g('Emails'),
        value: 'email',
        entities: ['email'],
        databot: 'order-overview__activity--email-list',
    },
    {
        label: Loc.g('Tâches'),
        value: 'task',
        entities: ['task'],
        databot: 'order-overview__activity--task-list',
    },
    {
        label: Loc.g('Evènements'),
        value: 'event',
        entities: ['event'],
        databot: 'order-overview__activity--event-list',
    },
    {
        label: Loc.g('Appels'),
        value: 'phonecall',
        entities: ['phonecall'],
        databot: 'order-overview__activity--call-list',
    },
    {
        label: Loc.g('Marketing'),
        value: 'marketing',
        entities: ['marketing'],
        databot: 'order-overview__activity--marketing-list',
    },
];

var entitiesGroups = [
    {
        label: Loc.g('Activité'),
        value: 'clientActivity',
        entities: [
            'task',
            'event',
            'annotation',
            'email',
            'phonecall',
            'client',
            'timetracking',
            'ticket',
            'snippettracking',
            'marketing',
        ],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['campaign', 'opportunity', 'estimate', 'propdocument'],
    },
    {
        type: 'component',
        component: 'timeline-author-filter',
        label: Loc.g('Collaborateurs'),
        value: 'authors',
        filter: true,
        entities: [],
        display: 'block',
    },
];

var defaultEntities = [
    'email',
    'phonecall',
    'client',
    'annotation',
    'event',
    'task',
    'timetracking',
    'ticket',
    'campaign',
    'opportunity',
    'estimate',
    'propdocument',
    'snippettracking',
    'marketing',
];

var forcedLabel = [
    {
        value: 'document',
        label: Loc.g('Mises à jour'),
    },
];

var availableStatCards = [
    'invoice_third',
    'estimate_third',
    'turnover_third',
    'top_selling_items_third',
    'sales_margin_third',
];

const databots = {
    activity: 'order-overview__menu--activity',
    informations: 'order-overview__menu--general-info',
    financialactivity: 'order-overview__menu--financial-info',
    contacts: 'order-overview__menu--contact-linked',
    addresses: 'order-overview__menu--address',
    customfields: 'order-overview__menu--cf',
    statistics: 'order-overview__menu--stat',
    opportunity: 'order-overview__menu--opportunity',
    estimate: 'order-overview__menu--document',
    invoice: 'order-overview__menu--document',
    delivery: 'order-overview__menu--document',
    order: 'order-overview__menu--document',
    creditnote: 'order-overview__menu--document',
    proforma: 'order-overview__menu--document',
    payments: 'order-overview__menu--payment',
    bankaccount: 'order-overview__menu--bank-account',
    recurring: 'order-overview__menu--recurring',
    mandates: 'order-overview__menu--mandate',
    timetracking: 'order-overview__menu--timetracking',
    tickets: 'order-overview__menu--ticket',
    project: 'order-overview__menu--project',
    proposal: 'order-overview__menu--proposal',
    emailingprofile: 'order-overview__menu--mailing-list',
    massmailingMailinglist: 'order-overview__menu--mailing-list',
    massmailingCampaignList: 'order-overview__menu--mailing-list',
    receipts: 'order-overview__menu--receipt',
    briefcase: 'order-overview__menu--briefcase',
    activitycommentadd: 'order-overview__activity--comment-add',
    emailadd: 'order-overview__activity--email-add',
    calladd: 'order-overview__activity--call-add',
    taskadd: 'order-overview__activity--task-add',
    eventadd: 'order-overview__activity--event-add',
    generalinfoedit1: 'order-overview__section--general-info-edit-1',
    generalinfoedit2: 'order-overview__section--general-info-edit-2',
    marketing: 'order-overview__section--marketing',
};

export {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    entitiesTabs,
    defaultEntities,
    entitiesGroups,
    forcedLabel,
    object,
    moreNav,
    availableStatCards,
    databots,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
};
